import Layout from "@layouts/withoutNaviagtion/withoutNavigationLayout";
import React, { useRef, useState, useEffect } from "react";
import LocationNavigation from "@components/Locations/location-navigation";
import { NavLink } from "react-router-dom";
import SimpleReactValidator from "simple-react-validator";
import { useParams, useNavigate } from "react-router-dom";
import InputField from "@_common/InputRuleFeild";
import { getValue } from "@utils/lodash";
import {
	adminGetCitiesListManagement,
	adminGetCountriesListManagement,
	adminGetListManagementGroupCode,
	adminGetStatesListManagement,
} from "@services/list-management.service";
import { toast } from "react-toastify";
import "./details.scss";
import moment from "moment";
import {
	clientCreateLocation,
	clientGetSpecificLocation,
	clientUpdateSpecificLocation,
} from "@services/location.service";
import { adminGetGroups } from "@services/groups.service";
import Loader from "@components/common/Loader";
import { useCallbackPrompt } from "../../../../prompt/useCallbackPrompt";
import _ from "lodash";
import PromptModal from "../../../../prompt/modal";
import { QueryRequestHelper } from "@_common/query-request-helper";
import NoAccessPage from "@components/common/NoAccess";
import { sanitizeInput } from "@_common/dompurify";
interface ILocationDetailProps {}

const LocationDetail: React.FunctionComponent<ILocationDetailProps> = (
	props: any
) => {
	let params = useParams();
	let navigate = useNavigate();
	/* -------------------------------------------------------------------------- */
	/*                               UseState Section                             */
	/* -------------------------------------------------------------------------- */
	const simpleValidator = useRef(new SimpleReactValidator());
	const [, forceUpdate] = useState(0);
	const [request, setRequest] = useState<any>({
		commencement_date: "",
		location_code: "",
		entity_name: "",
		location_name: "",
		industry: "",
		business_type: "",
		address1: "",
		address2: "",
		country_id: "101",
		state_id: "",
		city_id: "",
		pincode: "",
		region: "",
	});
	const [dirtyFields, setDirtyFields] = useState<any>({
		commencement_date: "",
		location_code: "",
		entity_name: "",
		location_name: "",
		industry: "",
		business_type: "",
		address1: "",
		address2: "",
		country_id: "101",
		state_id: "",
		city_id: "",
		pincode: "",
		region: "",
	});

	const reset = () => {
		setRequest({
			...request,
			country_id: "",
			state_id: "",
			city_id: "",
			group_id: "",
			address1: "",
			address2: "",
			entity_name: "",
			location_code: "",
			pincode: "",
			location_name: "",
			commencement_date: "",
			location_id: "",
			industry: "",
			business_type: "",
			region: "",
		});
		setDirtyFields({
			...dirtyFields,
			country_id: "",
			state_id: "",
			city_id: "",
			group_id: "",
			address1: "",
			address2: "",
			entity_name: "",
			location_code: "",
			pincode: "",
			location_name: "",
			commencement_date: "",
			location_id: "",
			industry: "",
			business_type: "",
			region: "",
		});
	};

	const [countryList, setCountryList] = useState([]);
	const [states, setStates] = useState([]);
	const [citiesList, setCityList] = useState([]);

	const [categoryOfLawList, setCategoryOfLawList] = useState([]);
	const [legislationList, setLegislationList] = useState([]);
	const [ruleList, setRuleList] = useState([]);

	const [frequencyList, setFrequencyList] = useState([]);
	const [documentTypeList, setDocumentTypeList] = useState([]);
	const [complianceTypeList, setComplianceTypeList] = useState([]);
	const [smartFilterList, setSmartFilterList] = useState([]);
	const [selectedSmartFilter, setSelectedSmartFilter] = useState([]);

	const [industryTypeList, setIndustryTypeList] = useState([]);
	const [businessTypeList, setBusinessTypeList] = useState([]);
	const [regionTypeList, setRegionTypeList] = useState([]);
	const [groupList, setGroupList] = useState([]);
	const [loading, setLoading] = useState(true);
	const [isLoading, setIsLoading] = useState(false);
	/* -------------------------------------------------------------------------- */
	/*                               UseEffect Section                            */
	/* -------------------------------------------------------------------------- */

	useEffect(() => {
		if (props.permissionAPITriggered) {
			getIndustryList();
			getBusinessTypeList();
			getRegionList();
			getCountriesList();

			if (getValue(params, `id`, "")) {
				getData(getValue(params, `id`, ""));
			} else {
				setTimeout(() => {
					setLoading(false);
				}, 100);
			}
			getGroupList();
		}
	}, [props.permissionAPITriggered]);

	useEffect(() => {
		if (request.country_id) {
			getStatesList(request.country_id);
		}
		if (request.state_id) {
			getCitiesList(request.state_id);
		}
	}, [request.country_id, request.state_id]);
	/* -------------------------------------------------------------------------- */
	/*                               API Section                                  */
	/* -------------------------------------------------------------------------- */

	const getData = async (id: string) => {
		try {
			setLoading(true);
			let resp = await clientGetSpecificLocation(id);
			if (resp) {
				setRequest({
					...request,
					country_id: getValue(resp, `data.country.id`, ""),
					state_id: getValue(resp, `data.state.id`, ""),
					city_id: getValue(resp, `data.city.id`, ""),
					group_id: getValue(resp, `data.group.id`, ""),
					address1: getValue(resp, `data.address1`, ""),
					address2: getValue(resp, `data.address2`, ""),
					entity_name: getValue(resp, `data.entity_name`, ""),
					location_code: getValue(resp, `data.location_code`, ""),
					pincode: getValue(resp, `data.pincode`, ""),
					location_name: getValue(resp, `data.location_name`, ""),
					commencement_date: getValue(resp, `data.commencement_date`, "")
						? new Date(getValue(resp, `data.commencement_date`, ""))
						: null,
					location_id: getValue(resp, `data.location_id`, ""),
					industry: getValue(resp, `data.industry.id`, ""),
					business_type: getValue(resp, `data.business_type.id`, ""),
					region: getValue(resp, `data.region.id`, ""),
				});
				setDirtyFields({
					...dirtyFields,
					country_id: getValue(resp, `data.country.id`, ""),
					state_id: getValue(resp, `data.state.id`, ""),
					city_id: getValue(resp, `data.city.id`, ""),
					group_id: getValue(resp, `data.group.id`, ""),
					address1: getValue(resp, `data.address1`, ""),
					address2: getValue(resp, `data.address2`, ""),
					entity_name: getValue(resp, `data.entity_name`, ""),
					location_code: getValue(resp, `data.location_code`, ""),
					pincode: getValue(resp, `data.pincode`, ""),
					location_name: getValue(resp, `data.location_name`, ""),
					commencement_date: getValue(resp, `data.commencement_date`, "")
						? new Date(getValue(resp, `data.commencement_date`, ""))
						: null,
					location_id: getValue(resp, `data.location_id`, ""),
					industry: getValue(resp, `data.industry.id`, ""),
					business_type: getValue(resp, `data.business_type.id`, ""),
					region: getValue(resp, `data.region.id`, ""),
				});

				setSelectedSmartFilter(
					getValue(resp, `data.smart_filter_tags`, []).map((item: object) => ({
						...item,
						value: getValue(item, `text`, ""),
						label: getValue(item, `text`, ""),
					}))
				);

				if (getValue(resp, `data.country.id`, "")) {
					getStatesList(getValue(resp, `data.country.id`, ""));
				}
				setLoading(false);
			} else {
				setLoading(false);
			}
		} catch (error) {
			setLoading(false);
		}
	};

	const getCountriesList = async () => {
		try {
			let resp = await adminGetCountriesListManagement();
			if (resp) {
				setCountryList(
					getValue(resp, `data.countries`, []).map((item: object) => ({
						...item,
						value: getValue(item, `name`, ""),
						label: getValue(item, `name`, ""),
					}))
				);
			} else {
			}
		} catch (error) {}
	};

	const getStatesList = async (countryId: number) => {
		try {
			let resp = await adminGetStatesListManagement(countryId);
			if (resp) {
				setStates(
					getValue(resp, `data.states`, []).map((item: object) => ({
						...item,
						value: getValue(item, `name`, ""),
						label: getValue(item, `name`, ""),
					}))
				);
			} else {
			}
		} catch (error) {}
	};

	const getIndustryList = async () => {
		try {
			let resp = await adminGetListManagementGroupCode("industry");
			if (resp) {
				let list = getValue(resp, `data.listItems`, []).filter((item: object) =>
					getValue(item, `is_active`, "")
				);
				setIndustryTypeList(
					list.map((item: object) => ({
						id: getValue(item, `id`, ""),
						is_active: getValue(item, `is_active`, ""),
						text: getValue(item, `text`, ""),
						value: getValue(item, `text`, ""),
						label: getValue(item, `text`, ""),
					}))
				);
			} else {
			}
		} catch (error) {}
	};
	const getGroupList = async () => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());

		let payload: any = {
			page_no: 1,
			page_size: 100,
		};
		let queryRequest = QueryRequestHelper(payload);
		try {
			let resp = await adminGetGroups(queryRequest);
			if (resp) {
				let list =
					getValue(resp, `data.groups.length`, 0) > 0
						? getValue(resp, `data.groups`, []).filter((item: object) =>
								getValue(item, `is_active`, "")
						  )
						: [];
				setGroupList(
					list.map((item: object) => ({
						...item,
						value: getValue(item, `group_name`, ""),
						label: getValue(item, `group_name`, ""),
					}))
				);
			} else {
			}
		} catch (error) {}
	};

	const getCitiesList = async (stateId: number) => {
		try {
			let resp = await adminGetCitiesListManagement(stateId);
			if (resp) {
				// console.log(resp);
				setCityList(
					getValue(resp, `data.cities`, []).map((item: object) => ({
						...item,
						value: getValue(item, `name`, ""),
						label: getValue(item, `name`, ""),
					}))
				);
			} else {
			}
		} catch (error) {}
	};

	const getRegionList = async () => {
		try {
			let resp = await adminGetListManagementGroupCode("region-type");
			if (resp) {
				let list =
					getValue(resp, `data.listItems.length`, 0) > 0
						? getValue(resp, `data.listItems`, []).filter((item: object) =>
								getValue(item, `is_active`, "")
						  )
						: [];
				setRegionTypeList(
					list.map((item: object) => ({
						id: getValue(item, `id`, ""),
						is_active: getValue(item, `is_active`, ""),
						text: getValue(item, `text`, ""),
						value: getValue(item, `text`, ""),
						label: getValue(item, `text`, ""),
					}))
				);
			} else {
			}
		} catch (error) {}
	};

	const getBusinessTypeList = async () => {
		try {
			let resp = await adminGetListManagementGroupCode("business-type");
			if (resp) {
				let list =
					getValue(resp, `data.listItems.length`, 0) > 0
						? getValue(resp, `data.listItems`, []).filter((item: object) =>
								getValue(item, `is_active`, "")
						  )
						: [];
				setBusinessTypeList(
					list.map((item: object) => ({
						id: getValue(item, `id`, ""),
						is_active: getValue(item, `is_active`, ""),
						text: getValue(item, `text`, ""),
						value: getValue(item, `text`, ""),
						label: getValue(item, `text`, ""),
					}))
				);
			} else {
			}
		} catch (error) {}
	};
	const handleSubmit = async () => {
		const formValid = simpleValidator.current.allValid();
		if (!formValid) {
			simpleValidator.current.showMessages();
			forceUpdate(1);
		} else {
			let payload = JSON.parse(JSON.stringify(request));
			payload.commencement_date = payload.commencement_date
				? moment(payload.commencement_date).format("YYYY-MM-DD")
				: null;
			payload.pincode = parseInt(payload.pincode);
			payload.country_id = parseInt(payload.country_id);
			payload.state_id = parseInt(payload.state_id);
			payload.city_id = parseInt(payload.city_id);

			// Object.keys(payload).forEach((key) => {
			// 	if (!payload[key] || payload[key] === undefined) {
			// 		delete payload[key];
			// 	}
			// });
			if (getValue(params, `id`, "")) {
				try {
					setIsLoading(true);
					let resp = await clientUpdateSpecificLocation(
						getValue(params, `id`, ""),
						payload
					);
					if (resp) {
						setIsLoading(false);
						confirmNavigation();
						toast.success(getValue(resp, "message", ""));
						getData(getValue(params, `id`, ""));
						// navigate(`/configuration/locations`);
					} else {
						confirmNavigation();
						setIsLoading(false);
					}
				} catch (error) {
					setIsLoading(false);
				}
			} else {
				try {
					setIsLoading(true);
					let resp = await clientCreateLocation(payload);
					if (resp) {
						setIsLoading(false);
						confirmNavigation();
						reset();
						toast.success(getValue(resp, "message", ""));
						navigate(`/configuration/locations`);
					} else {
						confirmNavigation();
						setIsLoading(false);
					}
				} catch (error) {
					setIsLoading(false);
				}
			}
		}
	};

	/* -------------------------------------------------------------------------- */
	/*                               Onchange section                             */
	/* -------------------------------------------------------------------------- */

	const handleChangeSelect = (e: any, type: string) => {
		if (type === "country_id") {
			getStatesList(e.id);
			setRequest({
				...request,
				country_id: e.id,
			});
		}
		if (type === "state_id") {
			getCitiesList(e.id);
			setRequest({
				...request,
				state_id: e.id,
			});
		}
		if (type === "industry") {
			setRequest({
				...request,
				industry: e.id,
			});
		}
		if (type === "business_type") {
			setRequest({
				...request,
				business_type: e.id,
			});
		}
		if (type === "city_id") {
			setRequest({
				...request,
				city_id: e.id,
			});
		}
		if (type === "region") {
			setRequest({
				...request,
				region: e.id,
			});
		}
		if (type === "group_id") {
			setRequest({
				...request,
				group_id: e.id,
			});
		}
	};

	const handleChangeText = (e: any) => {
		const { name, value } = e.target;
		setRequest({
			...request,
			[name]: sanitizeInput(value),
		});
	};

	const handleChangeDate = (e: any) => {
		setRequest({
			...request,
			commencement_date: e,
		});
	};

	const handleChangeSmartFilter = (e: any) => {
		setSelectedSmartFilter(e);
	};
	/* -------------------------------------------------------------------------- */
	/*                                Prompt Section                              */
	/* -------------------------------------------------------------------------- */
	const [isChanged, setIsChanged] = useState(false);
	useEffect(() => {
		setIsChanged(
			_.isEqualWith(request, dirtyFields, (a: any, b: any) => {
				// if both are null or equal to an empty string then they are equal
				if ((_.isNull(a) || a === "") && (_.isNull(b) || b === "")) return true;
			})
		);
	});
	const [showPrompt, confirmNavigation, cancelNavigation]: any =
		useCallbackPrompt(!isChanged);
	return (
		<Layout>
			<LocationNavigation id={params.id} />
			<PromptModal
				showDialog={showPrompt}
				confirmNavigation={confirmNavigation}
				cancelNavigation={cancelNavigation}
			/>
			{!loading &&
			!getValue(props, `subTabPermissionList`, []).includes(
				"configuration_location"
			) ? (
				<NoAccessPage />
			) : (
				<>
					{loading ? (
						<Loader />
					) : (
						<>
							<div className="user-details-wrapper m-0">
								<div className="checkpoint-active-details-wrapper__form-wrapper pt-5 mt-4">
									<div className="checkpoint-active-details-wrapper__form-content">
										<h4 className="mb-3">
											{getValue(params, `id`, "") ? "Update" : "Add"} Location
										</h4>
										<div className="user-details-wrapper__form user-details-wrapper__form--org-profile">
											{getValue(params, `id`, "") && (
												<div className="user-details-wrapper__form-group form-group">
													<label className="checkpoint-active-details__label">
														Auto Generated ID <span>*</span>
													</label>
													<InputField
														inputType="TEXT"
														placeholder="ID"
														className="form-control w-100"
														name="id"
														id="id"
														value={getValue(request, `location_id`, "")}
														disabled
													/>
												</div>
											)}

											<div className="user-details-wrapper__form-group form-group">
												<label className="checkpoint-active-details__label">
													Location Code <span>*</span>
												</label>
												<InputField
													inputType="TEXT"
													placeholder="Enter Location Code"
													className="form-control w-100"
													name="location_code"
													id="location_code"
													value={getValue(request, `location_code`, "")}
													onChange={(e: any) => handleChangeText(e)}
													label="Location Code"
													validator={simpleValidator}
												/>
											</div>

											<div className="user-details-wrapper__form-group form-group">
												<label className="checkpoint-active-details__label">
													Location Name <span>*</span>
												</label>
												<InputField
													inputType="TEXT"
													placeholder="Enter Location Name"
													className="form-control w-100"
													name="location_name"
													id="location_name"
													value={getValue(request, `location_name`, "")}
													onChange={(e: any) => handleChangeText(e)}
													label="Location Name"
													validator={simpleValidator}
												/>
											</div>

											<div className="user-details-wrapper__form-group form-group">
												<label className="checkpoint-active-details__label">
												Group/Account *
												</label>
												<InputField
													inputType="INPUT_REACT_SELECT"
													placeholder="Choose Group/Account"
													className="form-control w-100"
													name="group_id"
													id="group_id"
													options={groupList}
													value={groupList.filter(
														(item: object) =>
															getValue(item, `id`, "") ==
															getValue(request, `group_id`, "")
													)}
													onChange={(e: any) =>
														handleChangeSelect(e, "group_id")
													}
													label="Group/Account"
													validator={simpleValidator}
												/>
											</div>

											<div className="user-details-wrapper__form-group form-group">
												<label className="checkpoint-active-details__label">
													Entity Name <span>*</span>
												</label>
												<InputField
													inputType="TEXT"
													placeholder="Enter Entity Name"
													className="form-control w-100"
													name="entity_name"
													id="entity_name"
													value={getValue(request, `entity_name`, "")}
													onChange={(e: any) => handleChangeText(e)}
													label="Entity Name"
													validator={simpleValidator}
												/>
											</div>

											<div className="user-details-wrapper__form-group form-group">
												<label className="checkpoint-active-details__label">
													Industry <span>*</span>
												</label>
												<InputField
													inputType="INPUT_REACT_SELECT"
													placeholder="Enter Industry"
													className="form-control w-100"
													name="industry"
													id="industry"
													options={industryTypeList}
													value={industryTypeList.filter(
														(item: object) =>
															getValue(item, `id`, "") ==
															getValue(request, `industry`, "")
													)}
													onChange={(e: any) =>
														handleChangeSelect(e, "industry")
													}
													label="Industry"
													validator={simpleValidator}
												/>
											</div>

											<div className="user-details-wrapper__form-group form-group">
												<label className="checkpoint-active-details__label">
													Business Type <span>*</span>
												</label>
												<InputField
													inputType="INPUT_REACT_SELECT"
													placeholder="Enter Business Type"
													className="form-control w-100"
													name="business_type"
													id="business_type"
													options={businessTypeList}
													value={businessTypeList.filter(
														(item: object) =>
															getValue(item, `id`, "") ==
															getValue(request, `business_type`, "")
													)}
													onChange={(e: any) =>
														handleChangeSelect(e, "business_type")
													}
													label="Business Type"
													validator={simpleValidator}
												/>
											</div>

											<div className="user-details-wrapper__form-group form-group mt-2">
												<label className="checkpoint-active-details__label">
													Date Of Commencement <span></span>
												</label>
												<InputField
													inputType="DATETYPE-DOB"
													placeholder="Enter Commencement Date"
													className="form-control w-100"
													name="commencement_date"
													id="commencement_date"
													value={
														getValue(request, `commencement_date`, "")
															? getValue(request, `commencement_date`, "")
															: null
													}
													onChange={(e: any) => handleChangeDate(e)}
													label="Commencement Date"
													placeholderText={"MM/DD/YYYY"}
												/>
											</div>
											<div className="user-details-wrapper__form-group form-group mt-2">
												<label className="checkpoint-active-details__label">
													Country <span>*</span>
												</label>
												<InputField
													inputType="INPUT_REACT_SELECT"
													placeholder="Choose Country"
													className="form-control w-100"
													name="country_id"
													id="country_id"
													options={countryList}
													value={countryList.filter(
														(item: object) =>
															getValue(item, `id`, "") ==
															getValue(request, `country_id`, "")
													)}
													onChange={(e: any) =>
														handleChangeSelect(e, "country_id")
													}
													label="Country"
													validator={simpleValidator}
												/>
											</div>
											<div className="user-details-wrapper__form-group form-group mb-3 mt-2">
												<label className="checkpoint-active-details__label">
													Company Address (Line 1)<span>*</span>
												</label>
												<InputField
													inputType="TEXTAREAVENDOR"
													placeholder="Enter Company Address (Line 1)"
													className="text-area__form-control form-control w-100"
													name="address1"
													id="address1"
													label="Address Line1"
													value={getValue(request, `address1`, "")}
													onChange={(e: any) => handleChangeText(e)}
													validator={simpleValidator}
												/>
											</div>

											<div className="user-details-wrapper__form-group form-group mb-3">
												<label className="checkpoint-active-details__label">
													Company Address (Line 2)<span></span>
												</label>
												<InputField
													inputType="TEXTAREAVENDOR"
													placeholder="Enter Company Address (Line 2)"
													className="text-area__form-control form-control w-100"
													name="address2"
													id="address2"
													label="Address Line2"
													value={getValue(request, `address2`, "")}
													onChange={(e: any) => handleChangeText(e)}
													// validator={simpleValidator}
												/>
											</div>

											<div className="user-details-wrapper__form-group form-group">
												<label className="checkpoint-active-details__label">
													State <span>*</span>
												</label>
												<InputField
													inputType="INPUT_REACT_SELECT"
													placeholder="Choose State"
													className="form-control w-100"
													name="state_id"
													id="state_id"
													label="Last Name"
													options={states}
													value={states.filter(
														(item: object) =>
															getValue(item, `id`, "") ==
															getValue(request, `state_id`, "")
													)}
													onChange={(e: any) =>
														handleChangeSelect(e, "state_id")
													}
													validator={simpleValidator}
												/>
											</div>
											<div className="user-details-wrapper__form-group form-group">
												<label className="checkpoint-active-details__label">
													City <span>*</span>
												</label>
												<InputField
													inputType="INPUT_REACT_SELECT"
													placeholder="Choose State"
													className="form-control w-100"
													name="city_id"
													id="city_id"
													label="City"
													options={citiesList}
													value={citiesList.filter(
														(item: object) =>
															getValue(item, `id`, "") ==
															getValue(request, `city_id`, "")
													)}
													onChange={(e: any) =>
														handleChangeSelect(e, "city_id")
													}
													validator={simpleValidator}
												/>
											</div>

											<div className="user-details-wrapper__form-group form-group mt-2">
												<label className="checkpoint-active-details__label">
													Pincode <span></span>
												</label>
												<InputField
													inputType="NUMBER"
													placeholder="Enter Pincode"
													className="form-control w-100"
													name="pincode"
													id="pincode"
													value={getValue(request, `pincode`, "")}
													onChange={(e: any) => handleChangeText(e)}
													label="Pincode"
												/>
											</div>

											<div className="user-details-wrapper__form-group form-group mt-2">
												<label className="checkpoint-active-details__label">
													Region <span>*</span>
												</label>
												<InputField
													inputType="INPUT_REACT_SELECT"
													placeholder="Choose Region"
													className="form-control w-100"
													name="region"
													id="region"
													options={regionTypeList}
													value={regionTypeList.filter(
														(item: object) =>
															getValue(item, `id`, "") ==
															getValue(request, `region`, "")
													)}
													onChange={(e: any) => handleChangeSelect(e, "region")}
													label="Region"
													validator={simpleValidator}
												/>
											</div>
										</div>
										{getValue(props, `permissions`, []).includes("update") && (
											<div className="user-details-wrapper__cta-btns mt-2">
												<NavLink to={`/configuration/locations`}>
													<button className="ascent-button ascent-button--header-buttons ascent-button--primary">
														Cancel
													</button>
												</NavLink>
												{isLoading ? (
													<button className="ascent-button ascent-button--header-buttons ascent-button--secondary">
														Please wait...
													</button>
												) : (
													<button
														className={`ascent-button ascent-button--header-buttons ascent-button--${
															!isChanged ? "secondary" : "primary"
														}`}
														onClick={handleSubmit}
														disabled={isChanged}
													>
														{getValue(params, `id`, "") ? "Update" : "Submit"}
													</button>
												)}
											</div>
										)}
									</div>
								</div>
							</div>
						</>
					)}
					<div className="text-center">
						<img src="/images/footer-image.svg" className="img-fluid" />
					</div>
				</>
			)}
		</Layout>
	);
};

export default LocationDetail;
